module.exports = __webpack_public_path__ + "static/media/merchants-icon.c48d7227.svg";